import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const UserProfileSlide = createSlice({
    name: "userProfile",
    initialState: {
        updateUserProfileSuccess: false,
        updateUserProfileFail: false,
        updateUserProfileErrorDetail: null,

        sendVerificationEmailSuccess: false,
        sendVerificationEmailFail: false,
        sendVerificationEmailErrorDetail: null,

        sendCodeSuccess: false,
        sendCodeFail: false,
        sendCodeErrorDetail: null,

        confirmCodeSuccess: false,
        confirmCodeFail: false,
        confirmCodeErrorDetail: null,

        sendNewEmailCodeSuccess: false,
        sendNewEmailCodeFail: false,
        sendNewEmailCodeErrorDetail: null,

        confirmNewCodeSuccess: false,
        confirmNewCodeFail: false,
        confirmNewCodeErrorDetail: null,

        sendOTPCodeSuccess: false,
        sendOTPCodeFail: false,
        sendOTPCodeErrorDetail: null,

        verifyOTPCodeSuccess: false,
        verifyOTPCodeFail: false,
        verifyOTPCodeErrorDetail: null,
    },
    reducers: {
        doUpdateUserProfileSuccess: (state, action) => {
            state.updateUserProfileSuccess = true;
            state.updateUserProfileFail = false;
            state.updateUserProfileErrorDetail = null;
        },
        doUpdateUserProfileFail: (state, action) => {
            state.updateUserProfileSuccess = false;
            state.updateUserProfileFail = true;
            state.updateUserProfileErrorDetail = action.payload.data;
        },
        resetUpdateUserProfileState: (state, action) => {
            state.updateUserProfileSuccess = false;
            state.updateUserProfileFail = false;
            state.updateUserProfileErrorDetail = null;
        },
        //
        doSendVerificationEmailSuccess: (state, action) => {
            state.sendVerificationEmailSuccess = true;
            state.sendVerificationEmailFail = false;
            state.sendVerificationEmailErrorDetail = null;
        },
        doSendVerificationEmailFail: (state, action) => {
            state.sendVerificationEmailSuccess = false;
            state.sendVerificationEmailFail = true;
            state.sendVerificationEmailErrorDetail = action.payload.data;
        },
        resetSendVerificationEmailState: (state, action) => {
            state.sendVerificationEmailSuccess = false;
            state.sendVerificationEmailFail = false;
            state.sendVerificationEmailErrorDetail = null;
        },
        //
        doSendChangeEmailVerificationCodeSuccess: (state, action) => {
            state.sendCodeSuccess = true;
            state.sendCodeFail = false;
            state.sendCodeErrorDetail = null;
        },
        doSendChangeEmailVerificationCodeFail: (state, action) => {
            state.sendCodeSuccess = false;
            state.sendCodeFail = true;
            state.sendCodeErrorDetail = action.payload.data;
        },
        resetSendChangeEmailVerificationCodeState: (state, action) => {
            state.sendCodeSuccess = false;
            state.sendCodeFail = false;
            state.sendCodeErrorDetail = null;
        },
        //
        doConfirmChangeEmailVerificationCodeSuccess: (state, action) => {
            state.confirmCodeSuccess = true;
            state.confirmCodeFail = false;
            state.confirmCodeErrorDetail = null;
        },
        doConfirmChangeEmailVerificationCodeFail: (state, action) => {
            state.confirmCodeSuccess = false;
            state.confirmCodeFail = true;
            state.confirmCodeErrorDetail = action.payload.data;
        },
        resetConfirmChangeEmailVerificationCodeState: (state, action) => {
            state.confirmCodeSuccess = false;
            state.confirmCodeFail = false;
            state.confirmCodeErrorDetail = null;
        },
        //
        doSendNewEmailVerificationCodeSuccess: (state, action) => {
            state.sendNewEmailCodeSuccess = true;
            state.sendNewEmailCodeFail = false;
            state.sendNewEmailCodeErrorDetail = null;
        },
        doSendNewEmailVerificationCodeFail: (state, action) => {
            state.sendNewEmailCodeSuccess = false;
            state.sendNewEmailCodeFail = true;
            state.sendNewEmailCodeErrorDetail = action.payload.data;
        },
        resetSendNewEmailVerificationCodeState: (state, action) => {
            state.sendNewEmailCodeSuccess = false;
            state.sendNewEmailCodeFail = false;
            state.sendNewEmailCodeErrorDetail = null;
        },
        //
        doConfirmNewEmailVerificationCodeSuccess: (state, action) => {
            state.confirmNewCodeSuccess = true;
            state.confirmNewCodeFail = false;
            state.confirmNewCodeErrorDetail = null;
        },
        doConfirmNewEmailVerificationCodeFail: (state, action) => {
            state.confirmNewCodeSuccess = false;
            state.confirmNewCodeFail = true;
            state.confirmNewCodeErrorDetail = action.payload.data;
        },
        resetConfirmNewEmailVerificationCodeState: (state, action) => {
            state.confirmNewCodeSuccess = false;
            state.confirmNewCodeFail = false;
            state.confirmNewCodeErrorDetail = null;
        },
        //
        doSendOTPCodeSuccess: (state, action) => {
            state.sendOTPCodeSuccess = true;
            state.sendOTPCodeFail = false;
            state.sendOTPCodeErrorDetail = null;
        },
        doSendOTPCodeFail: (state, action) => {
            state.sendOTPCodeSuccess = false;
            state.sendOTPCodeFail = true;
            state.sendOTPCodeErrorDetail = action.payload.data;
        },
        resetSendOTPCodeState: (state, action) => {
            state.sendOTPCodeSuccess = false;
            state.sendOTPCodeFail = false;
            state.sendOTPCodeErrorDetail = null;
        },
        //
        doVerifyOTPCodeSuccess: (state, action) => {
            state.verifyOTPCodeSuccess = true;
            state.verifyOTPCodeFail = false;
            state.verifyOTPCodeErrorDetail = null;
        },
        doVerifyOTPCodeFail: (state, action) => {
            state.verifyOTPCodeSuccess = false;
            state.verifyOTPCodeFail = true;
            state.verifyOTPCodeErrorDetail = action.payload.data;
        },
        resetVerifyOTPCodeState: (state, action) => {
            state.verifyOTPCodeSuccess = false;
            state.verifyOTPCodeFail = false;
            state.verifyOTPCodeErrorDetail = null;
        },
    },
});

export const doUpdateUserProfile = (param, SSMFileValue, SSTFileValue, businessCardFileValue) => async (dispatch) => {
	try {
        let formData = new FormData();

        for (const field in param) {
            const value = param[field];

            if (value !== null && value !== '') {
                formData.append(
                    field, value
                );
            }
        }

        if (SSMFileValue.length > 0) {
            SSMFileValue.forEach((file, index) => {
                formData.append(`ssm_file`, file);
            });
        }

        if (SSTFileValue.length > 0) {
            SSTFileValue.forEach((file, index) => {
                formData.append(`sst_file`, file);
            });
        }

        if (businessCardFileValue.length > 0) {
            businessCardFileValue.forEach((file, index) => {
                formData.append(`business_card_file`, file);
            });
        }

        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        const url = `/api/customer/auth/me`;    

        const response = await axios.put(url, formData, config);

        dispatch(doUpdateUserProfileSuccess(response.data));
    } catch (error) {
        dispatch(doUpdateUserProfileFail(error.response));
    }
};

export const doResetUpdateUserProfileState = () => async (dispatch) => {
    dispatch(resetUpdateUserProfileState());
};

export const doSendVerificationEmail = () => async (dispatch) => {
	try {
        const url = `/api/customer/auth/send-verify-email`;
        const response = await axios.post(url);

        dispatch(doSendVerificationEmailSuccess(response.data));
    } catch (error) {
        dispatch(doSendVerificationEmailFail(error.response));
    }
};

export const doResetSendVerificationEmailState = () => async (dispatch) => {
    dispatch(resetSendVerificationEmailState());
};

export const doSendChangeEmailVerificationCode = () => async (dispatch) => {
	try {
        const url = `/api/customer/auth/change-email/send-verify-code`;
        const response = await axios.post(url);

        dispatch(doSendChangeEmailVerificationCodeSuccess(response.data));
    } catch (error) {
        dispatch(doSendChangeEmailVerificationCodeFail(error.response));
    }
};

export const doResetSendChangeEmailVerificationCodeState = () => async (dispatch) => {
    dispatch(resetSendChangeEmailVerificationCodeState());
};

export const doConfirmChangeEmailVerificationCode = (param) => async (dispatch) => {
	try {
        const url = `/api/customer/auth/change-email/confirm-verify-code`;
        const response = await axios.post(url, param);

        dispatch(doConfirmChangeEmailVerificationCodeSuccess(response.data));
    } catch (error) {
        dispatch(doConfirmChangeEmailVerificationCodeFail(error.response));
    }
};

export const doResetConfirmChangeEmailVerificationCodeState = () => async (dispatch) => {
    dispatch(resetConfirmChangeEmailVerificationCodeState());
};

export const doSendNewEmailVerificationCode = (param) => async (dispatch) => {
	try {
        const url = `/api/customer/auth/change-email/send-verify-code-new-email`;
        const response = await axios.post(url, param);

        dispatch(doSendNewEmailVerificationCodeSuccess(response.data));
    } catch (error) {
        dispatch(doSendNewEmailVerificationCodeFail(error.response));
    }
};

export const doResetSendNewEmailVerificationCodeState = () => async (dispatch) => {
    dispatch(resetSendNewEmailVerificationCodeState());
};

export const doConfirmNewEmailVerificationCode = (param) => async (dispatch) => {
	try {
        const url = `/api/customer/auth/change-email/confirm-verify-code-new-email`;
        const response = await axios.post(url, param);

        dispatch(doConfirmNewEmailVerificationCodeSuccess(response.data));
    } catch (error) {
        dispatch(doConfirmNewEmailVerificationCodeFail(error.response));
    }
};

export const doResetConfirmNewEmailVerificationCodeState = () => async (dispatch) => {
    dispatch(resetConfirmNewEmailVerificationCodeState());
};

export const doSendOTPCode = (param) => async (dispatch) => {
	try {
        const url = `/api/customer/auth/otp/resend`;
        const response = await axios.post(url, param);

        dispatch(doSendOTPCodeSuccess(response.data));
    } catch (error) {
        dispatch(doSendOTPCodeFail(error.response));
    }
};

export const doResetSendOTPCodeState = () => async (dispatch) => {
    dispatch(resetSendOTPCodeState());
};

export const doVerifyOTPCode = (param) => async (dispatch) => {
	try {
        const url = `/api/customer/auth/otp/verify`;
        const response = await axios.post(url, param);

        dispatch(doVerifyOTPCodeSuccess(response.data));
    } catch (error) {
        dispatch(doVerifyOTPCodeFail(error.response));
    }
};

export const doResetVerifyOTPCodeState = () => async (dispatch) => {
    dispatch(resetVerifyOTPCodeState());
};

export const {
    doUpdateUserProfileSuccess,
    doUpdateUserProfileFail,
    resetUpdateUserProfileState,
    doSendVerificationEmailSuccess,
    doSendVerificationEmailFail,
    resetSendVerificationEmailState,
    doSendChangeEmailVerificationCodeSuccess,
    doSendChangeEmailVerificationCodeFail,
    resetSendChangeEmailVerificationCodeState,
    doConfirmChangeEmailVerificationCodeSuccess,
    doConfirmChangeEmailVerificationCodeFail,
    resetConfirmChangeEmailVerificationCodeState,
    doSendNewEmailVerificationCodeSuccess,
    doSendNewEmailVerificationCodeFail,
    resetSendNewEmailVerificationCodeState,
    doConfirmNewEmailVerificationCodeSuccess,
    doConfirmNewEmailVerificationCodeFail,
    resetConfirmNewEmailVerificationCodeState,
    doSendOTPCodeSuccess,
    doSendOTPCodeFail,
    resetSendOTPCodeState,
    doVerifyOTPCodeSuccess,
    doVerifyOTPCodeFail,
    resetVerifyOTPCodeState,
} = UserProfileSlide.actions;

export const getUpdateUserProfileSuccess = (state) => state.userProfile?.updateUserProfileSuccess;
export const getUpdateUserProfileFail = (state) => state.userProfile?.updateUserProfileFail;
export const getUpdateUserProfileErrorDetail = (state) => state.userProfile?.updateUserProfileErrorDetail;

export const getSendVerificationEmailSuccess = (state) => state.userProfile?.sendVerificationEmailSuccess;
export const getSendVerificationEmailFail = (state) => state.userProfile?.sendVerificationEmailFail;
export const getSendVerificationEmailErrorDetail = (state) => state.userProfile?.sendVerificationEmailErrorDetail;

export const getSendChangeEmailVerificationCodeSuccess = (state) => state.userProfile?.sendCodeSuccess;
export const getSendChangeEmailVerificationCodeFail = (state) => state.userProfile?.sendCodeFail;
export const getSendChangeEmailVerificationCodeErrorDetail = (state) => state.userProfile?.sendCodeErrorDetail;

export const getConfirmChangeEmailVerificationCodeSuccess = (state) => state.userProfile?.confirmCodeSuccess;
export const getConfirmChangeEmailVerificationCodeFail = (state) => state.userProfile?.confirmCodeFail;
export const getConfirmChangeEmailVerificationCodeErrorDetail = (state) => state.userProfile?.confirmCodeErrorDetail;

export const getSendNewEmailVerificationCodeSuccess = (state) => state.userProfile?.sendNewEmailCodeSuccess;
export const getSendNewEmailVerificationCodeFail = (state) => state.userProfile?.sendNewEmailCodeFail;
export const getSendNewEmailVerificationCodeErrorDetail = (state) => state.userProfile?.sendNewEmailCodeErrorDetail;

export const getConfirmNewEmailVerificationCodeSuccess = (state) => state.userProfile?.confirmNewCodeSuccess;
export const getConfirmNewEmailVerificationCodeFail = (state) => state.userProfile?.confirmNewCodeFail;
export const getConfirmNewEmailVerificationCodeErrorDetail = (state) => state.userProfile?.confirmNewCodeErrorDetail;

export const getSendOtpCodeSuccess = (state) => state.userProfile?.sendOTPCodeSuccess;
export const getSendOtpCodeFail = (state) => state.userProfile?.sendOTPCodeFail;
export const getSendOtpCodeErrorDetail = (state) => state.userProfile?.sendOTPCodeErrorDetail;

export const getVerifyOtpCodeSuccess = (state) => state.userProfile?.verifyOTPCodeSuccess;
export const getVerifyOtpCodeFail = (state) => state.userProfile?.verifyOTPCodeFail;
export const getVerifyOtpCodeErrorDetail = (state) => state.userProfile?.verifyOTPCodeErrorDetail;

export default UserProfileSlide.reducer;
